import { HAIR_COLOR_OPTIONS } from '../HAIR_COLOR_OPTIONS';
import { HairColorOptionIdType } from '../types';

const DEFAULT: HairColorOptionIdType = 'blonde';

export const getHairColorIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): HairColorOptionIdType | null => {
  const id = HAIR_COLOR_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
